import Drawer from 'expo-router/drawer';
import type { DrawerType } from 'hooks/useDrawerType';
import { useFiniteState } from 'hooks/useFiniteState';
import { DrawerNavigatorContent } from 'navigation/DrawerNavigatorContent';
import { useCommonDrawerProps } from 'navigation/drawerStyles';
import { SafeAreaProvider } from 'react-native-safe-area-context';

export default function Layout() {
  const screenOptions = useCommonDrawerProps();
  const drawerType = useFiniteState<DrawerType>(screenOptions.drawerType);
  return (
    <SafeAreaProvider>
      <Drawer
        screenOptions={{
          ...screenOptions,
          drawerType: drawerType.value,
          headerShown: drawerType.value !== 'permanent',
        }}
        drawerContent={(props) => <DrawerNavigatorContent {...props} />}
      >
        <Drawer.Screen
          name="onboard"
          options={{
            title: 'Onboard patient',
          }}
        />
        <Drawer.Screen
          name="device"
          options={{
            title: 'Devices',
          }}
        />
        <Drawer.Screen
          name="device-association"
          options={{
            title: 'Device Associations',
          }}
        />
        <Drawer.Screen
          name="practitioner"
          options={{
            title: 'Practitioners',
          }}
        />
        <Drawer.Screen
          name="group"
          options={{
            title: 'Groups',
          }}
        />
        <Drawer.Screen
          name="organization"
          options={{
            title: 'Organizations',
          }}
        />
        <Drawer.Screen
          name="location"
          options={{
            title: 'Locations',
          }}
        />
        <Drawer.Screen
          name="charge-item"
          options={{
            title: 'Charge Items',
          }}
        />
        <Drawer.Screen
          name="claim-template"
          options={{
            title: 'Claim Templates',
          }}
        />
        <Drawer.Screen
          name="claim"
          options={{
            title: 'Claims',
          }}
        />
        <Drawer.Screen
          name="care-team"
          options={{
            title: 'Care Teams',
          }}
        />
      </Drawer>
    </SafeAreaProvider>
  );
}
